function Cache (limit = 100) {
  this.cache = {}
  this.keys = []
  this.limit = limit
  return this
}
Cache.prototype = {
  get: function (key) {
    return this.cache[key]
  },
  set: function (key, value) {
    let { keys, limit, cache } = this
    if (keys.length >= limit) {
      let k = keys.shift()
      delete cache[k]
    }
    this.keys.push(key)
    cache[key] = value
  },
  resolve: function (key, resolve) {
    let r = this.cache[key]
    if (r) {
      setTimeout(() => {
        resolve(r)
      }, 100)
      return true
    }
    return false
  }
}
export default function (limit) {
  return new Cache(limit)
}
